export function useFocus() {
  const focusById = (id: string) => {
    document.getElementById(id)?.focus();
  };

  return { focusById };
}
